// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notice-preview[data-v-44e92f16]{margin:24px 0;padding-top:20px;border-top:1px solid #e8edf1}.notice-preview h3[data-v-44e92f16]{font-size:15px;margin:0 0 16px}.notice-files-title[data-v-44e92f16]{margin-top:20px;color:#7c8896}.notice-empty[data-v-44e92f16]{color:#8a96a3}.notice-content-frame[data-v-44e92f16]{width:100%;height:60vh;border:0}", ""]);
// Exports
module.exports = exports;
